import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Documents/Personal/GitProject/frog-kits/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "frog-ui"
    }}>{`Frog-UI`}</h2>
    <h3 {...{
      "id": "演示站点"
    }}>{`演示站点`}</h3>
    <p><a parentName="p" {...{
        "href": "https://frog-ui.vercel.app/"
      }}>{`https://frog-ui.vercel.app/`}</a></p>
    <h3 {...{
      "id": "安装"
    }}>{`安装`}</h3>
    <h4 {...{
      "id": "使用-npm-或-yarn-安装"
    }}>{`使用 `}<inlineCode parentName="h4">{`npm`}</inlineCode>{` 或 `}<inlineCode parentName="h4">{`yarn`}</inlineCode>{` 安装`}</h4>
    <pre><code parentName="pre" {...{}}>{`npm install frog-ui --save
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`yarn add frog-ui
`}</code></pre>
    <p>{`如果你的网络环境不佳，推荐使用 `}<inlineCode parentName="p">{`cnpm`}</inlineCode>{`。`}</p>
    <h4 {...{
      "id": "浏览器引入"
    }}>{`浏览器引入`}</h4>
    <p>{`在浏览器中使用 `}<inlineCode parentName="p">{`script`}</inlineCode>{` 和 `}<inlineCode parentName="p">{`link`}</inlineCode>{` 标签直接引入文件，并使用全局变量 `}<inlineCode parentName="p">{`Frog`}</inlineCode>{`。`}</p>
    <p><inlineCode parentName="p">{`npm`}</inlineCode>{` 发布包内的 `}<inlineCode parentName="p">{`frog-ui/dist`}</inlineCode>{` 目录下提供了 `}<inlineCode parentName="p">{`frog.js`}</inlineCode>{` `}<inlineCode parentName="p">{`frog.css`}</inlineCode>{` 以及 `}<inlineCode parentName="p">{`frog.min.js`}</inlineCode>{` `}<inlineCode parentName="p">{`frog.min.css`}</inlineCode>{`。你也可以通过 `}<inlineCode parentName="p">{`CDN`}</inlineCode>{` 或 `}<inlineCode parentName="p">{`UNPKG`}</inlineCode>{` 进行下载。`}</p>
    <blockquote>
      <p parentName="blockquote">{`强烈不推荐使用已构建文件，这样无法按需加载。`}<br parentName="p"></br>{`
`}<inlineCode parentName="p">{`frog.js`}</inlineCode>{` 和 `}<inlineCode parentName="p">{`frog.min.js`}</inlineCode>{` 依赖 `}<inlineCode parentName="p">{`react/react-dom`}</inlineCode>{`，请确保提前引入这些文件。`}</p>
    </blockquote>
    <h3 {...{
      "id": "示例"
    }}>{`示例`}</h3>
    <pre><code parentName="pre" {...{}}>{`import { Button } from 'frog-ui';

ReactDOM.render(<Button type="primary">按钮<Button>, mountNode);
`}</code></pre>
    <p>{`引入样式：`}</p>
    <pre><code parentName="pre" {...{}}>{`import 'frog-ui/dist/frog.min.css';
`}</code></pre>
    <h4 {...{
      "id": "按需加载"
    }}>{`按需加载`}</h4>
    <p><inlineCode parentName="p">{`frog-ui`}</inlineCode>{` 的 `}<inlineCode parentName="p">{`JS`}</inlineCode>{` 代码默认支持基于 `}<inlineCode parentName="p">{`ES modules`}</inlineCode>{` 的 `}<inlineCode parentName="p">{`tree shaking`}</inlineCode>{`。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      